<script lang="ts" setup>
defineProps<{ icon: string }>()
</script>

<template>
  <button
    type="button"
    class="flex-shrink-0 flex items-center justify-center
      text-grey-500 hover:text-primary-base active:text-primary-dark stroke-2
    "
    :style="{ height: '48px', width: '48px' }"
  >
    <GIcon :icon="icon" size="30px"/>
  </button>
</template>
